export default "__VITE_ASSET__DOgn5TRs__"